import { Directive, effect, inject, input, output } from '@angular/core';

import { ChipComponent } from '@shared/chip';

@Directive({
  selector: 'ml-chip[mlSelectable]',
  host: {
    '(click)': 'toggle()',
  },
})
export class SelectableDirective {
  readonly isSelected = input.required<boolean>();

  protected readonly toggled = output<void>();

  protected readonly host = inject(ChipComponent);

  constructor() {
    effect(() => {
      this.host.isSelected.set(this.isSelected());
    });
  }

  toggle(): void {
    this.toggled.emit();
  }
}
